export default __webpack_public_path__ + "static/media/playing.85cb4736.png";